<template>
  <template v-if="isLoaded">
    <div class="menu-view">
      <div class="farm-window text-window" id="help-window">
        <div>
          <h2>Credits</h2>
        </div>
        <TextButton class="farm-button" @click="$emit('close')">
          <h3>X</h3>
        </TextButton>
        <div class="farm-list help-list">
          <div class="farm-window credits-block">
            <h3>Development and Design</h3>
            <p>Gardamuse</p>
          </div>
          <div class="farm-window credits-block">
            <h3>Graphics</h3>
            <p>Background image by <a href="https://unsplash.com/photos/QcBAZ7VREHQ">Frances Gun at Unsplash</a></p>
          </div>
          <div class="farm-window credits-block">
            <h3>Support</h3>
            <p>Everyone who supports Blushing Defeat on Patreon!</p>
            <br style="margin: 10px;">
            <PatreonButton></PatreonButton>
          </div>
          <div class="farm-window credits-block">
            <h3>Beta Testers</h3>
            <p>b1acksteve</p>
            <p>Weunderstandj00</p>
            <p>Hoshi</p>
            <p>Kakae1459</p>
            <p>SoylentOrange</p>
            <p>Isaac Storm</p>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import util from '../../util'
import TextButton from '@/components/ui/TextButton.vue'
import SavesCard from '@/components/SavesCard.vue'
import SaveSystem from '@/SaveSystem'
import PatreonButton from '@/components/ui/PatreonButton.vue'
import { Personality } from "@/employee/Personality"
import { allPersonalities } from "@/employee/Personalities"

@Options({
  components: {
    TextButton, PatreonButton
  },
  props: {
    saveSystem: Object
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    },
    window() {
      return window
    },
    allPersonalities(): Personality[] {
      return Object.entries(allPersonalities()).map(value => value[1])
    }
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class CreditsScreen extends Vue {
  isLoaded = false
  saveSystem!: SaveSystem
}
</script>

<style scoped lang="scss">

.menu-view {
  //max-width: $full-page-width;
  height: 100vh;

  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr;
  grid-template-areas:
    "t"
    "t";
  grid-gap: 20px;

  @media screen and (max-width: $mobile-width){
    grid-template-areas:
      "t"
      "t";
    margin: 0;
  }
}

.text-window {
  grid-area: t;

  box-sizing: border-box;
  flex-direction: column;
  min-height: 200px;
  max-height: 100%;
  width: 100%;
  max-width: 700px;
  margin: 20px auto;
  padding: 20px;

  display: grid;
  grid-template-rows: 30px auto;
  grid-template-columns: auto 50px;
  grid-template-areas:
    "t x"
    "c c";
  grid-gap: 10px;

  p {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  @media screen and (max-width: $mobile-width){
    padding: 10px;
    margin: 0 auto;
  }
}

.patreon-button {
  grid-area: p;

  box-sizing: border-box;
  margin: auto;
  width: 100%;
  max-width: 600px;
  max-height: 150px;
}

.start-menu-text {
  background: $component-background-color;
  margin: 10px auto 50px auto;
  width: 100%;
  box-sizing: border-box;
}

.start-menu-buttons {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: center;

  .text-button {
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
    margin: 5px 0;
  }
}

.blushing-defeat-button-row {
  grid-template-columns: 1fr !important;
  height: 50px;
  margin-top: auto;
}

.stat-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: minmax(40px, 1fr);
}

.text-button {
  border: $component-border-style;

  display: table;
  div {
    display: table-cell;
    vertical-align: middle;
  }

  & > h3 {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
}

.help-list {
  grid-area: c;

  //max-height: 100vh;
  //height: 100%;
  overflow-y: auto;

  .farm-window {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }

  p {
    margin: 0;
  }
}

</style>
